module.exports = __webpack_public_path__ + "static/the-pragmatic-programmer-8121dc48ec937ecf919bc2c54aa961a4.jpeg";